export const env = { ...process.env, ...window['__env'] };
